import React from 'react';
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Button,
	Zoom,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import logo from './../../assets/images/logos/m-clean.png';
import SuccessAnimationAlert from '../alerts/SuccessAnimationAlert';
import ReplyForm from '../forms/ReplyForm';
import InfoMessage from '../alerts/InfoMessage';
import ReviewTable from '../reviews/ReviewTable';

const useStyles = makeStyles((theme) => ({
	dialog: {
		maxWidth: '60%'
	},
	label: {
		marginBottom: '5px',
		textAlign: 'left',
		fontSize: '14px',
		color: 'rgba(0, 0, 0, 0.87)'
	}
}));

const ReviewReplyDialog = (props) => {

	const classes = useStyles();

 	return (
 		<>
	    	<Dialog 
	    		open={props.dialogIsOpen} 
				onClose={(event, reason) => {
                    if(reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                        props.handleDialogClose(true)
                    }
                }}
	    		aria-labelledby="form-dialog-message" 
	    		fullWidth 
			//	classes={{ paperFullWidth: classes.dialog }}
	    		maxWidth="sm"
	    		TransitionComponent={Zoom}
	    	>
				<DialogTitle 
					id="form-dialog-message" 
					className="dialog-title"
				>
					<img src={logo} className="mr-1" alt="Mulk.pk" />
					Review Reply
				</DialogTitle>
				<DialogContent>
					<div className="container mt-2">
						
						{props.confirmation && (
							<SuccessAnimationAlert 
								title="Thank You!"
								text="Your message has been sent successfully. You can now close this window."
							/>
						)} 

						{!props.confirmation && ( 
							<>
								<ReviewTable
									review={props.review} 
								/>

								<InfoMessage
									title="Remember, Keep your response simple and friendly."
									message="Thank the reviewer for their business and review. Respond publicly when you have something to add to the user's review and respond with a direct message if you simply want to say thank you." 
								/>

								<div className="custom-form-new">     
									<ReplyForm 
										reviewId={props.review.id} 
										listingId={props.review.listing_id}
										replyType={props.replyType}
										confirmation={props.confirmation}
										setConfirmation={props.setConfirmation}
									/>
								</div>
							</>
						)}

			        </div>
				</DialogContent>
		        <DialogActions className="dialog-footer">
		          	<Button onClick={props.handleDialogClose} color="primary">
		            	Cancel
		          	</Button>
		        </DialogActions>
			</Dialog>
		</>
  	)
}

export default ReviewReplyDialog;